import actionTypes from '../constants/action-types';

const updatePageSettings = (pageId, settings, options = {}) => ({
  type: actionTypes.UPDATE_PAGE_SETTINGS,
  payload: {
    pageId,
    settings,
    options,
  },
});

export default updatePageSettings;
